import paymentImage from '@/common/images/common/payment';

export function getPaymentImage( payment: string ): string | undefined {

    switch ( payment ) {

        case 'paypal': return paymentImage.paypal;

        case 'visa': return paymentImage.visa;

        case 'mastercard-1': return paymentImage.mastercard;

        case 'american-express': return paymentImage.american;

        case 'discover': return paymentImage.discover;

    }

}
